import { Box } from '@material-ui/core';
import React from 'react';
import '../../resources/css/animate.scss'
/**
 * 骨架屏
 * - 用于数据未加载完全，暂时显示简易的元素。
 * - @param delay 组件内部主动延迟功能（适用于组件元素过多，且需要进行动画，）
 */
export default function Skeleton(props: { children: JSX.Element, show?: boolean, className?: string, style?: React.CSSProperties, delay?: number, }) {
    const { children, show, className, style, delay } = props;
    const [localShow, setLocalShow] = React.useState(true);

    // 组件内部主动延迟
    React.useEffect(() => {
        if (delay) {
            setTimeout(() => {
                setLocalShow(false);
            }, delay);
        }
    })

    return (
        <>
            {(delay ? !localShow : !show) && children}
            <Box
                // hidden={delay ? localShow : show}
                className={`MuiSkeleton-wave ${className || ''}`}
                style={{
                    opacity: (delay ? localShow : show) ? 1 : 0,
                    visibility: (delay ? localShow : show) ? 'visible' : 'hidden',
                    ...style
                }}
            />
        </>
    )
}